
      var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgQrIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "qr-icon_0eebdc2301647738__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 8,
  height: 8,
  rx: 1
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 8,
  height: 8,
  rx: 1,
  stroke: "#000",
  strokeWidth: 3.2,
  mask: "url(#qr-icon_0eebdc2301647738__a)"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "qr-icon_0eebdc2301647738__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 13,
  width: 8,
  height: 8,
  rx: 1
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 13,
  width: 8,
  height: 8,
  rx: 1,
  stroke: "#000",
  strokeWidth: 3.2,
  mask: "url(#qr-icon_0eebdc2301647738__b)"
})), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
  id: "qr-icon_0eebdc2301647738__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 3,
  width: 8,
  height: 8,
  rx: 1
}))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 3,
  width: 8,
  height: 8,
  rx: 1,
  stroke: "#000",
  strokeWidth: 3.2,
  mask: "url(#qr-icon_0eebdc2301647738__c)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #9631ff)",
  d: "M13 13h2v2h-2zM15 15h2v2h-2zM17 13h2v2h-2zM13 17h2v2h-2zM15 19h2v2h-2zM17 17h2v2h-2zM19 15h2v2h-2zM19 19h2v2h-2z"
})));

      const __svgRaw = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<mask id=\"path-1-inside-1_9032_819\" fill=\"white\">\r\n<rect x=\"3\" y=\"3\" width=\"8\" height=\"8\" rx=\"1\"/>\r\n</mask>\r\n<rect x=\"3\" y=\"3\" width=\"8\" height=\"8\" rx=\"1\" stroke=\"black\" stroke-width=\"3.2\" mask=\"url(#path-1-inside-1_9032_819)\"/>\r\n<mask id=\"path-2-inside-2_9032_819\" fill=\"white\">\r\n<rect x=\"3\" y=\"13\" width=\"8\" height=\"8\" rx=\"1\"/>\r\n</mask>\r\n<rect x=\"3\" y=\"13\" width=\"8\" height=\"8\" rx=\"1\" stroke=\"black\" stroke-width=\"3.2\" mask=\"url(#path-2-inside-2_9032_819)\"/>\r\n<mask id=\"path-3-inside-3_9032_819\" fill=\"white\">\r\n<rect x=\"13\" y=\"3\" width=\"8\" height=\"8\" rx=\"1\"/>\r\n</mask>\r\n<rect x=\"13\" y=\"3\" width=\"8\" height=\"8\" rx=\"1\" stroke=\"black\" stroke-width=\"3.2\" mask=\"url(#path-3-inside-3_9032_819)\"/>\r\n<rect x=\"13\" y=\"13\" width=\"2\" height=\"2\" fill=\"var(--theme-primary, #9631ff)\"/>\r\n<rect x=\"15\" y=\"15\" width=\"2\" height=\"2\" fill=\"var(--theme-primary, #9631ff)\"/>\r\n<rect x=\"17\" y=\"13\" width=\"2\" height=\"2\" fill=\"var(--theme-primary, #9631ff)\"/>\r\n<rect x=\"13\" y=\"17\" width=\"2\" height=\"2\" fill=\"var(--theme-primary, #9631ff)\"/>\r\n<rect x=\"15\" y=\"19\" width=\"2\" height=\"2\" fill=\"var(--theme-primary, #9631ff)\"/>\r\n<rect x=\"17\" y=\"17\" width=\"2\" height=\"2\" fill=\"var(--theme-primary, #9631ff)\"/>\r\n<rect x=\"19\" y=\"15\" width=\"2\" height=\"2\" fill=\"var(--theme-primary, #9631ff)\"/>\r\n<rect x=\"19\" y=\"19\" width=\"2\" height=\"2\" fill=\"var(--theme-primary, #9631ff)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/qr-icon.0eebdc230164773888a341a8edbe3061.svg"),
        {
          React: SvgQrIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      